export const TenantSettings = {
    TimesheetResponsibility: 'TimesheetResponsibilityType',
    AssignmentCancellationThreshold: 'AssignmentCancellationThreshold',
    AssignmentCancellationMinimumCharge: 'AssignmentCancellationMinimumCharge',
    /** FeatureFlag 62: the day the tenant week starts on (0 = Sunday ... 6 = Saturday). Drives dispatch, job weeks and the pay workweek. */
    WeekStartsOn: 'PayPeriodBeginDayOfWeek',
    PayPeriodTypeId: 'PayPeriodTypeId',
    BiweeklyPayPeriodStartDate: 'BiweeklyPayPeriodStartDate',
    CrewsEnabled: 'CrewsEnabled',
    DispatchHoursEnabled: 'DispatchHoursEnabled',
    RollUpDriveTime: 'RollUpDriveTime',
    DefaultChargeEnabled: 'DefaultChargeEnabled',
    JobUploadsEnabled: 'JobUploadsEnabled',
    PayrollEnabled: 'PayrollEnabled',
    BillingEnabled: 'BillingEnabled',
    BillingRatesEnabled: 'BillingRatesEnabled',
    TimesheetAdjustmentsEnabled: 'TimesheetAdjustmentsEnabled',
    EmployeeOnboardingEnabled: 'EmployeeOnboardingEnabled',
    EmployeeOnboardingDefaultGroup: 'EmployeeOnboardingDefaultGroup',
    TimesheetEmergencyEnabled: 'TimesheetEmergencyEnabled',
    TimesheetEmergencyStart: 'TimesheetEmergencyStart',
    TimesheetEmergencyEnd: 'TimesheetEmergencyEnd',
    TimesheetEmergencyPayTypeId: 'TimesheetEmergencyPayTypeId',
    TimesheetEmergencyPayAdjustment: 'TimesheetEmergencyPayAdjustment',
    TimesheetEmailEnabled: 'TimesheetEmailEnabled',
    TimesheetExportEnabled: 'TimesheetExportEnabled',
    UseLimitedApprovals: 'UseLimitedApprovals',
    BlockBillingCancelEnabled: 'BlockBillingCancelEnabled',
    BlockPayrollCancelEnabled: 'BlockPayrollCancelEnabled',
    InvoicingEnabled: 'InvoicingEnabled',
    ChargeTypeGroupsEnabled: 'ChargeTypeGroupsEnabled',
    EnablePredefinedTimesheetMissingSigReason:
        'EnablePredefinedTimesheetMissingSigReason',
    EnableSelfDispatchTimesheets: 'EnableSelfDispatchTimesheets',
    ContactScreenEnabled: 'ContactScreenEnabled',
    ContactActivitiesEnabled: 'ContactActivitiesEnabled',
    UseStateMinimum: 'UseStateMinimum',
    EnableAlternateBillTo: 'EnableAlternateBillTo',
    TimesheetUseJobCity: 'TimesheetUseJobCity',
    TimesheetEquipmentAuditEnabled: 'TimesheetEquipmentAuditEnabled',
    AllowCrossDispatching: 'AllowCrossDispatching',
    CaptureCounty: 'CaptureCounty',
    GoogleMapsApiKey: 'GoogleMapsApiKey',
    IncludeSchedulingOnDailyJobExport: 'IncludeSchedulingOnDailyJobExport',
    EmployeeLongTermStatusManagementEnabled:
        'EmployeeLongTermStatusManagementEnabled',
    EnableCertification: 'EnableCertification',
    EnableCustomizedHoliday: 'EnableCustomizedHoliday',
    ForceAllChargesInTimesheetExport: 'ForceAllChargesInTimesheetExport',
    AttendanceEventsEnabled: 'AttendanceEventsEnabled',
    DispatchStatusFilterEnabled: 'DispatchStatusFilterEnabled',
    ShowLongTermStatusCountOnRoster: 'ShowLongTermStatusCountOnRoster',
    EnableContractDateRange: 'EnableContractDateRange',
    ContractExpiryDistributionList: 'ContractExpiryDistributionList',
    ContractExpiryCompanyName: 'ContractExpiryCompanyName',
    AllowDefaultChargeTypeValues: 'AllowDefaultChargeTypeValues',
    AllowTimesheetStatusRollbacks: 'AllowTimesheetStatusRollbacks',
    BannerMessage: 'BannerMessage',
    BannerMessageExternallyVisible: 'BannerMessageExternallyVisible',
    EnableAutoEscalatingContractRates: 'EnableAutoEscalatingContractRates',
    EnablePrevailingWageContracts: 'EnablePrevailingWageContracts',
    GLStringsEnabled: 'GLStringsEnabled',
    ShowContractDescriptionInTimesheetView:
        'ShowContractDescriptionInTimesheetView',
    ActiveEmployeeListEnabled: 'ActiveEmployeeListEnabled',
    EnableStaffingReport: 'EnableStaffingReport',
    StaffingReportDistributionList: 'StaffingReportDistributionList',
    EnableNewCustomerBillableHoursReport:
        'EnableNewCustomerBillableHoursReport',
    NewCustomerBillableHoursReportDistributionList:
        'NewCustomerBillableHoursReportDistributionList',
    EnableRequestedPersonnel: 'EnableRequestedPersonnel',
    EnableDriverReportingInTimesheet: 'EnableDriverReportingInTimesheet',
    EnableAFADChargeTypeGrouping: 'EnableAFADChargeTypeGrouping',
    EnableJobOverrides: 'EnableJobOverrides',
    EnableDoubleTimeBilling: 'EnableDoubleTimeBilling',
    EnableDoubleTimePayroll: 'EnableDoubleTimePayroll',
    EnableAlternativePayrollBilling: 'EnableAlternativePayrollBilling',
    EnforceContractUnionWork: 'EnforceContractUnionWork',
    TimesheetEmailReplyTo: 'TimesheetEmailReplyTo',
    TimesheetEmailBcc: 'TimesheetEmailBcc',
    TimesheetEmailFromName: 'TimesheetEmailFromName',
    QuirksEnabled: 'QuirksEnabled',
    EnableRegularShiftDifferential: 'EnableRegularShiftDifferential',
    RegularShiftDifferentialStart: 'RegularShiftDifferentialStart',
    RegularShiftDifferentialEnd: 'RegularShiftDifferentialEnd',
    EnableDriverRideConfirmationFields: 'EnableDriverRideConfirmationFields',
    ContractsCanEnforceProjectManagers: 'ContractsCanEnforceProjectManagers',
    SubmittedTimesheetsReportEmailList: 'SubmittedTimesheetsReportEmailList',
    EnableEstimate: 'EnableEstimate',
    EnableContractCreation: 'EnableContractCreation',
    UseContractProjects: 'UseContractProjects',
    ConstrainContactTypesOnJobEnabled: 'ConstrainContactTypesOnJobEnabled',
    EmployeeImportSwitchEnabled: 'EmployeeImportSwitchEnabled',
    HasHoursReport: 'HasHoursReport',
    JobAssignmentCancellationSMSTemplate: 'JobAssignmentCancellationSMSTemplate',
    JobAssignmentClientCancellationSMSTemplate: 'JobAssignmentClientCancellationSMSTemplate',
    JobAssignmentOverrideSMSTemplate: 'JobAssignmentOverrideSMSTemplate',
    JobAssignmentSMSTemplate: 'JobAssignmentSMSTemplate',
    JobTitleTemplate: 'JobTitleTemplate',
    TimesheetRejectSMSTemplate: 'TimesheetRejectSMSTemplate',
    UseQuickBooksInvoicing: 'UseQuickBooksInvoicing',
    AFADChargeTypeGroupingEnabled: 'AFADChargeTypeGroupingEnabled',
    EnableDoubleTime: 'EnableDoubleTime',
    TimeZone: 'TimeZone',
    EnablePreJobForm: 'EnablePreJobForm',
    DailyGSFReportEmailList: 'DailyGSFReportEmailList',
    DailyOperationalReportEmailList: 'DailyOperationalReportEmailList',
    AllowRentalChargeTypes: 'AllowRentalChargeTypes',
    TimesheetFlagEnabled: 'TimesheetFlagEnabled',
    EnableDriverPaySources: 'EnableDriverPaySources',
    RetainClientSignatureOnUpdate: 'RetainClientSignatureOnUpdate',
    PrintForemanOnInvoiceDetails: 'PrintForemanOnInvoiceDetails',
    ShowWorkCardOnTimesheet: 'ShowWorkCardOnTimesheet',
    EnableWorkCardValidation: 'EnableWorkCardValidation',
    HideInvoicePrefixOnPrint: 'HideInvoicePrefixOnPrint',
    DisableJobOverrideTimeRestriction: 'DisableJobOverrideTimeRestriction',
    EnableUnion40OTBilling: 'EnableUnion40OTBilling',
    EnableShiftDifferentialBilling: 'EnableShiftDifferentialBilling',
    ShiftDifferentialPayAdjustment: 'ShiftDifferentialPayAdjustment',
    EnableEquipmentTags: 'EnableEquipmentTags',
    EnableBillPeriods: 'EnableBillPeriods',
    ShowTimesheetStatusHistory: 'ShowTimesheetStatusHistory',
    SetInvoiceDateBasedOnLastTimesheet: 'SetInvoiceDateBasedOnLastTimesheet',
    EnableQuickSales: 'EnableQuickSales',
    CombineRentalNonRentalChargesOnRentalInvoices: 'CombineRentalNonRentalChargesOnRentalInvoices',
    EnablePayrollStatusInChargeView: 'EnablePayrollStatusInChargeView',
    RemittanceAddressOnPrintedInvoice: 'RemittanceAddressOnPrintedInvoice',
    FooterNotesOnPrintedInvoice: 'FooterNotesOnPrintedInvoice',
    EnablePayIncentivesforCertifications: 'EnablePayIncentivesforCertifications',
    NetSuiteInvoiceForm: 'NetSuiteInvoiceForm',
    NetSuiteICInvoiceForm: 'NetSuiteICInvoiceForm',
    NetSuiteICEndInvoiceForm: 'NetSuiteICEndInvoiceForm',
    NetSuiteICOffice: 'NetSuiteICOffice',
    NetSuiteDescriptionItem: 'NetSuiteDescriptionItem',
    NetSuiteICDescriptionItem: 'NetSuiteICDescriptionItem',
    NetSuitePercentageItem: 'NetSuitePercentageItem',
    NetSuiteMultiSubcontractor: 'NetSuiteMultiSubcontractor',
    NetSuiteInvoiceCustomerPickup: 'NetSuiteInvoiceCustomerPickup',
    CertifiedPayrollReporterName: 'CertifiedPayrollReporterName',
    CertifiedPayrollReporterTitle: 'CertifiedPayrollReporterTitle',
    PayrollAppTypeId: 'PayrollAppTypeId',
    PayrollAppId: 'PayrollAppId',
    PayrollAppApiKey: 'PayrollAppApiKey',
    PayrollAppApiSecret: 'PayrollAppApiSecret',
    EnableSundayOT: 'EnableSundayOT',
    EnableHolidayOT: 'EnableHolidayOT',
    FringePaidInCash: 'FringePaidInCash',
    EnableMonthEndRentalInvoice: 'EnableMonthEndRentalInvoice',
    UseRadioStyleDaySelection: 'UseRadioStyleDaySelection',
    EnableContractTimesheetCheckins: 'EnableContractTimesheetCheckins',
    AllowTimesheetAttachments: 'AllowTimesheetAttachments',
    MapId: 'MapId',
    UrlSegment: 'UrlSegment',
    EnableContractJobTypeBillingSetting: 'EnableContractJobTypeBillingSetting',
    IncludeEquipmentResourceNameInInvoice: 'IncludeEquipmentResourceNameInInvoice',
    ApplyDTtoFullShift: 'ApplyDTtoFullShift',
    AutoCalculateDriveTimeBilling: 'AutoCalculateDriveTimeBilling',
    QuickRentalContractTemplateId: 'QuickRentalContractTemplateId',
    ExemptLateArrivalsFromBumpRules: 'ExemptLateArrivalsFromBumpRules',
    EnablePrevailingWageCountyGroups: 'EnablePrevailingWageCountyGroups',
    IncludeMedicareDeductionsInFICAColumn: 'IncludeMedicareDeductionsInFICAColumn',
    EnablePaintBatchCodes: 'EnablePaintBatchCodes',
    DisplayJobTypeInTimesheetManagement: 'DisplayJobTypeInTimesheetManagement',
    EnablePremiumPayroll: 'EnablePremiumPayroll',
    EnableWeekendShiftDifferential: 'EnableWeekendShiftDifferential',
    EnableWAHR: 'EnableWAHR',
    EnablePremiumBilling: 'EnablePremiumBilling',
    RequireResourceKitOnJobBuild: 'RequireResourceKitOnJobBuild',
};